import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react'
import Select from 'react-select'
import AsyncCreatableSelect from 'react-select/async-creatable'
import { Card, ContentLoader } from '../../../../_components'
import { SimpleFetch, SimpleFetchResponse, store } from '../../../../_helpers'
import styles from '../../styles.module.scss'
import { removeErrorDisplay } from '../../_functions'

const filtersComparations = [
  { label: "Igual a", value: "==" },
  { label: "Diferente de", value: "!=" },
  { label: "Contém", value: "contain" },
  { label: "Não contém", value: "notcontain" }
]

export function Filter({data, setData, domain, errors, setErrors, disabled = false}) {
  const dataFilters = useMemo( () => {
    const filter = ( data.momentums ?? [] ).find( ( { type } ) => type === 'filter' )
    return filter?.values?.[0]
  }, [ data ] )

  const firstDataFilters = useRef( dataFilters )

  const [ filters, setFilters ] = useState({available: [], values: []})
  const [ loadingCustomFilters, setLoadingCustomFilters ] = useState(false)

  const { available: filtersAvailable } = filters

  useEffect( () => {
    const data = firstDataFilters.current
    if ( filtersAvailable?.length && data ) {
      const filter = filtersAvailable.find( filter => data.filter === filter.value )
      const comparation = filtersComparations.find( comparation => comparation.value === data.comparation )
      const values = data.value?.map( value => ( { label: value, value } ) ) ?? []

      if ( !filter ) return void 0

      setData( state => ( {
        ...state,
        filter: {
          comparation: comparation?.value,
          filter: filter.value,
          label: filter.label,
          value: data.value
        },
        raw_filter_type: filter,
        raw_filter_comparation: comparation,
        raw_filter_value: values,
      } ) )

      if ( filter.value === 'all' ) return void 0
      
      setLoadingCustomFilters(true)

      SimpleFetch(`GET`, {}, {}, `momentum`, `person/search/${domain}/filter/${filter.value}`)
        .then( response => {
          if ( response.status !== 200 ) return Promise.reject( response )
          const arr = response.data.map( ( { name } ) => ( { label: name, value: name } ) )
          setFilters( filters => ( { ...filters, values: arr } ) )
          setLoadingCustomFilters(false)
        } )
        .catch( response => {
          SimpleFetchResponse( response, "Não foi possível listar os filtros disponíveis. Tente novamente mais tarde.", "Filtros disponíveis." )
        } )
    }
  }, [ filtersAvailable, setData, domain ] )

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (!domain) domain = store.getState().changeDomainReducer.selectedDomain.domain_uuid

    async function getFilters() {
      const req = await SimpleFetch(`GET`, {}, {}, `momentum`, `person/filter/${domain}`)
      if ( req.status !== 200 ) return

      let arr = []
      req.data.map(filter => arr.push({label: filter.name, value: filter.key}))

      setFilters({available: arr})
    }
    getFilters()
  }, [sessionStorage.getItem('selected_domain')])

  const handleChange = async (e, type) => {
    removeErrorDisplay(type, errors, setErrors)

    if ( !e || !type ) {
      let arr = data
      delete arr.value
      return setData(arr)
    }

    const raw = `raw_${type}`
    let arr = data.filter ? data.filter : [];

    if ( type === "filter_type" && e.value !== "all" ) {
      setLoadingCustomFilters(true)

      const req = await SimpleFetch(`GET`, {}, {}, `momentum`, `person/search/${domain}/filter/${e.value}`)
      if ( req.status !== 200 ) {
        SimpleFetchResponse(req, "Não foi possível listar os filtros disponíveis. Tente novamente mais tarde.", "Filtros disponíveis.")
      }

      const arr = req.data.map( ( { name } ) => ( { label: name, value: name } ) )

      setFilters( filters => ( { ...filters, values: arr } ) )
      setLoadingCustomFilters(false)
    }
    type = type.split('_')[1]
    if (type === "type") type = "filter"
    
    if ( Array.isArray(e) ) {
      const values = e.map(d => d.value)
      e.value = values
    }

    if ( e.value === "all" ) {
      delete data.filter
      return setData({...data, filter: {[type]: e.value}, [raw]: e})
    }

    setData({...data, filter: {...arr, [type]: e.value}, [raw]: e})
  }

  const handleUpdateFilters = useCallback( async (e) => {
    const domain = store.getState().changeDomainReducer.selectedDomain.domain_uuid
    const filter = data.filter
      ? Array.isArray( data.filter )
        ? data.filter[0]
        : data.filter
      : data.momentums?.find( momentum => momentum.type === 'filter' )?.values?.[0]
        ?? null

    if ( !filter ) return void 0

    const res = await SimpleFetch(`GET`, {}, {}, `momentum`, `person/search/${domain}/filter/${filter.filter}?search=${e}`);

    if ( !res ) return void 0

    const updatedFilters = res.data
      .filter( ( item ) => !!item?.name && !!item?.value )
      .map( ( { name: label, value } ) => ( { label, value } ) );

    return updatedFilters
  }, [ data ] )

  return (
    <Card
      title="Filtros"
      icon="FunnelIcon"
      description={"Filtrar para quem será enviado as notificações. <strong>Exemplo</strong>: pode ser por país, cidade ou para toda a base."}
      required={true}
      help={"O filtro é utilizado para segmentar sua base baseado em dados já existentes. Caso escolha a opção Mobile > Sim, todos que estão registrados em sua base usando dispositivos móveis serão impactados."}
    >
      {
        filters.available && filters.available.length !== 0 ?
          <div className={`input__group ${loadingCustomFilters && "input__group--nowrap"}`}>
            <Select
              className={`
                selectable
                ${loadingCustomFilters && "w-full"}
                ${errors.filterType ? "selectable--error" : ""}
              `}
              value={data.raw_filter_type}
              isDisabled={disabled}
              // defaultValue={data.raw_filter_type}
              options={filters.available}
              onChange={e => handleChange(e, 'filter_type')}
              placeholder="Selecione o tipo de filtro"
              noOptionsMessage={() => "Nenhuma opção disponível"}
            />

            {
              !loadingCustomFilters ? <>
                {
                  data.raw_filter_type &&
                  data.raw_filter_type.value !== "all" && <>
                    <Select
                      className={`
                        selectable
                        ${( data.raw_filter_type && data.raw_filter_type.value === "all" ) || !data.filter ? "selectable__disabled" : ""}
                        ${errors.filterComparation && "selectable--error"}
                      `}
                      value={data.raw_filter_comparation}
                      options={filtersComparations}
                      onChange={e => handleChange(e, 'filter_comparation')}
                      placeholder="Selecione uma condição"
                      isDisabled={disabled || ( ( data.raw_filter_type && data.raw_filter_type.value === "all" ) || !data.filter ) ? true : false}
                    />

                    <AsyncCreatableSelect
                      className={`
                        selectable 
                        ${!data.raw_filter_comparation && "selectable__disabled"}
                        ${errors.filterValue && "selectable--error"}
                      `}
                      isClearable
                      isMulti
                      cacheOptions
                      value={data.raw_filter_value}
                      onChange={(e) => handleChange(e, 'filter_value')}
                      placeholder="Insira o valor referente"
                      isDisabled={disabled || !data.raw_filter_comparation ? true : false}
                      defaultOptions={filters.values}
                      loadOptions={handleUpdateFilters}
                    />
                  </>
                }
              </> : <>
                <ContentLoader height="50px" spaceBetween={true}/>
                <ContentLoader height="50px" spaceBetween={true}/>
              </>
            }
          </div>
        : <div className={styles["loader__group"]}>
            <ContentLoader height="50px" spaceBetween={true}/>
            <ContentLoader height="50px" spaceBetween={true}/>
            <ContentLoader height="50px" spaceBetween={true}/>
          </div>
      }
    </Card>
  )
}